module.exports = __webpack_public_path__ + "static/media/291327.5360109a.png";